// FAQSection.jsx
import React from 'react';
import styles from './../style/MobFMenu.module.scss';

import { Image } from 'react-bootstrap'

const MobFMenu = ({ options, changeTopSearch, userProfileType }) => {

  const phones = options?.phones?.[userProfileType] || [];

  return (
    <>
      <div className={styles.menu + ` d-md-none`}>
        {phones.length > 0 &&
          <a title={phones[0]} href={`tel:` + phones[0].replace(/[-()\s]/g, '')} className={styles.menu_el}>
            <Image src="/images/fmenu/phone.svg" width="15" height="15" alt="Позвонить" />
            <div>Позвонить</div>
          </a>
        }
        <div onClick={changeTopSearch} className={styles.menu_el}>
          <Image src="/images/fmenu/search.svg" width="15" height="15" alt="Поиск" />
          <div>Поиск</div>
        </div>
        {/*
        <a className={styles.menu_logo} href="/">
          <Image src="/images/fmenu/logo.png" width="96" height="21" alt="Лого" />
        </a>
        */}
        <a className={styles.menu_el} href={options?.link_cart || '/'}>
          <Image src="/images/fmenu/cart.svg" width="15" height="15" alt="Корзина" />
          <div>Корзина</div>
        </a>
        <a className={styles.menu_el} href={options?.link_catalog || '/'}>
          <Image src="/images/fmenu/catalog.svg" width="15" height="15" alt="Каталог" />
          <div>Каталог</div>
        </a>
      </div>
      <div className={styles.menu_podmena + ` d-md-none`}></div>
    </>
  );
};

export default MobFMenu;